import React from 'react';
import './FinancialLeasingSystem.scss';
import financing_secure from '../../assets/financing_Image/financing_15.png';
import financing_diamond from '../../assets/financing_Image/financing_16.png';
import financing_excellent_1 from '../../assets/financing_Image/financing_10.png';
import financing_excellent_2 from '../../assets/financing_Image/financing_11.png';
import financing_excellent_3 from '../../assets/financing_Image/financing_12.png';
import financing_excellent_4 from '../../assets/financing_Image/financing_12_2.png';
import financing_excellent_5 from '../../assets/financing_Image/financing_13.png';
import financing_excellent_6 from '../../assets/financing_Image/financing_14.png';
import angryLittleGirl from '../../assets/angryLittleGirl.png';

const financialLeasingText =
  '挚云数科坚持科技+运营的理念，专注于金融行业软件开发，提供最专业、最高效的供应链金融科技系统与运营服务，服务包括实体企业、第三方机构及金融机构在内的参与各方，致力于构建覆盖供应链金融全流程的生态系统。';
// 融资租赁
const FinancialLeasingSystem = () => {
  const DiamondList = [
    {
      title: '分摊与调拨',
      text: '支持多种口径分摊，用户可自定义分摊规则和分摊动因,对调拨进行全流程支持,满足财务入账、管理分析、业绩考核的要求',
      img: financing_excellent_2,
    },
    {
      title: '出租及转租',
      text: '支持自有租入资产-站式管理,出租/转租场景自动核算及收款分析管理，帮助企业轻松应对出租和转租复杂场景',
      img: financing_excellent_3,
    },
    {
      title: '动态资金模型',
      text: '内置20+种租金模型，可根据条件及算法自动将合同租金拆分至预计合同现金流,满足企业租金模型多样化的需求',
      img: financing_excellent_4,
    },
    {
      title: '支付流程管理',
      text: '帮助企业对租金支付环节的事前提醒、支付流程、支付入账、差异处理、账龄分析进行全流程精细化管理',
      img: financing_excellent_5,
    },
  ];
  const SolutionList = [
    {
      title: '合同全生命周期管理',
      text: '提供可配置的合同模板，用户可自定义合同的字段、算法、审批流、BU口径上的分摊逻辑，满足企业管理、核算及内部控制要求',
    },
    {
      title: '分摊与调拨',
      text: '支持多种口径分摊，用户可自定义分摊规则和分摊动因,对调拨进行全流程支持,满足财务入账、管理分析、业绩考核的要求',
    },
    {
      title: '出租及转租',
      text: '支持自有租入资产-站式管理,出租/转租场景自动核算及收款分析管理，帮助企业轻松应对出租和转租复杂场景',
    },
    {
      title: '动态资金模型',
      text: '内置20+种租金模型，可根据条件及算法自动将合同租金拆分至预计合同现金流,满足企业租金模型多样化的需求',
    },
    {
      title: '支付流程管理',
      text: '帮助企业对租金支付环节的事前提醒、支付流程、支付入账、差异处理、账龄分析进行全流程精细化管理',
    },
    {
      title: '多准则自动核算',
      text: '预置多准则核算规则，可同时出具满足新、旧准则以及税务要求的分录，满足新增合同初始和后续计量，及合同修改变更的核算要求',
      image: '',
    },
    {
      title: 'ERP及其他系统对接',
      text: '提供多种ERP系统同步方案，将符合新租赁准则的凭证数据推送至ERP总账、应付、报销等系统，帮助企业解决系统对接难题',
    },
    {
      title: '存量合同过渡方案',
      text: '内置过渡期方案模拟测算功能，能够帮助用户测算几种不同方案下的财务结果，为选择过渡期方案提供依据',
    },
  ];
  const ExcellentList = [
    {
      title: '合同多场景全生命周期管理',
      text: '内置20+种租金模型，模拟测算合同现金流计划，记录合同新增、变更、终止全过程，实现合同入账-预测-支付全流程管理',
      img: financing_excellent_1,
    },
    {
      title: '业财智能化效率提升60%',
      text: '支持多种口径分摊，用户可自定义分摊规则和分摊动因,对调拨进行全流程支持,对业务变化进行智能记录，三大会计报表实时更新，一键批量处理，进度一目了然，帮助企业实时掌握业务和财务情况',
      img: financing_excellent_2,
    },
    {
      title: '报表出具自动化一键实时可查询',
      text: '支持自有租入资产-站式管理,出租/报表钻取至相应的合同或凭证，通过数据可视化展示，帮助企业实时查询利润表、资产负债表、现金流量表等',
      img: financing_excellent_3,
    },
    {
      title: '需求多种多样一个系统全搞定',
      text: '内置20+种租金模型，可根据条件及算法自动将合同租金拆分至预计合同现金流,内置多种功能板块，满足IFRS16/CAS21/ASC842多准则自动核算，承租人、出租人及转租人多角色核算，财务报表、审计披露等不同需求',
      img: financing_excellent_4,
    },
    {
      title: '成熟产品和模型，快速上线',
      text: '产品成熟而可快速交付，简单配即可使用，且具备强大的可扩展性和灵活性。支持大数据架构，满足TB级数据查询计算',
      img: financing_excellent_5,
    },
    {
      title: '多个成功案例，轻松应对新准则',
      text: ' 积累了大量办公租赁、经营租赁、资产租赁等不同场景应用案例，帮助集团性企业、零售连锁、金融等行业客户轻松应对新准则',
      img: financing_excellent_6,
    },
  ];
  return (
    <div className="financial-main">
      <div className="financial-main-introduce">
        <div className="title-weight">
          <div className="title-ch">融资租赁系统软件介绍</div>
          <div className="title-en">
            INTRODUCTION TO FINANCIAL LEASING SYSTEM SOFTWARE
          </div>
          <div className="horizontal-line" />
        </div>
        <div className="leasing-software-introduction">
          <div className="leasing-software-introduction-img">
            <img src={angryLittleGirl} alt="" />
          </div>
          <div className="leasing-software-introduction-text">
            {financialLeasingText}
          </div>
        </div>
      </div>
      <div className="financial_center">
        <div className="financial-main">
          <div className="title-weight">
            <div className="title-ch">解决方案</div>
            <div className="title-en ">SOLUTION</div>
            <div className="horizontal-line" />
          </div>
          <div className="financial_diamond">
            <img className="diamond" src={financing_diamond} alt="" />

            {DiamondList.map((item, ind) => {
              return (
                <div className="financial_diamond_item" key={ind}>
                  <div>
                    <p className="financial_diamond_item_title">{item.title}</p>
                    <div className="financial_diamond_item_text">
                      {item.text}
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="Dharma_a" />
            <div className="Dharma_b" />
            <div className="Dharma_c" />
            <div className="Dharma_d" />
          </div>
        </div>
        {/* 产品特点 */}
        <div className="Features">
          <div className="title-weight">
            <div className="title-ch">产品特点</div>
            <div className="title-en">PRODUCT FEATURES</div>
            <div className="horizontal-line" />
          </div>
          <div className="financial_rosy">
            {SolutionList.map((item, ind) => {
              return (
                <div className="financial_rosy_item" key={ind}>
                  <div className="financial_rosy_title">{item.title}</div>
                  <div className="financial_rosy_text">{item.text}</div>
                </div>
              );
            })}
          </div>
        </div>
        {/* 产品优势 */}
        <div className="excellent">
          <div className="title-weight">
            <div className="title-ch">产品优势</div>
            <div className="title-en">PRODUCT ADVANTAGES</div>
            <div className="horizontal-line" />
          </div>
          <div className="excellent_rosy">
            {ExcellentList.map((item, ind) => {
              return (
                <div className="excellent_rosy_item" key={ind}>
                  <div style={{ height: '150px' }}>
                    <img src={item.img} alt="" />
                  </div>

                  <div className="excellent_rosy_title">{item.title}</div>
                  <div className="excellent_rosy_text">{item.text}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="financial-main-secure">
        <div className="title-weight">
          <div className="title-ch">融资租赁系统功能模块</div>
          <div className="title-en ">
            FINANCIAL LEASING SYSTEM FUNCTIONAL MODULE
          </div>
        </div>
        <div className="financing_secure">
          <img src={financing_secure} alt="" />
        </div>
      </div>
    </div>
  );
};

export default FinancialLeasingSystem;
